/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_FlavorsInputs */

const en_manage_flavors = /** @type {(inputs: Manage_FlavorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Flavors`)
};

const es_manage_flavors = /** @type {(inputs: Manage_FlavorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar sabores`)
};

/**
* | output |
* | --- |
* | "Manage Flavors" |
*
* @param {Manage_FlavorsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_flavors = /** @type {((inputs?: Manage_FlavorsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_FlavorsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_flavors(inputs)
	return es_manage_flavors(inputs)
});